// This file is autogenerated by tools/compressTextures. DO NOT EDIT IT DIRECTLY.

export const textureNames = [
  "DV_Grunge_Clouds_0",
  "DV_Grunge_Clouds_1",
  "DV_Grunge_Clouds_2",
  "DV_Grunge_Fibers_0",
  "DV_Grunge_Fibers_2",
  "DV_Grunge_Grass_0",
  "DV_Grunge_Grass_2",
  "DV_Grunge_Grimes_0",
  "DV_Grunge_Grimes_1",
  "DV_Grunge_Grimes_2",
  "DV_Grunge_Noise_1",
  "DV_Grunge_Noise_2",
  "DV_Grunge_Noise_White",
  "DV_Grunge_Smears_0",
  "DV_Grunge_Smears_1",
  "DV_Grunge_Smears_2",
  "DV_Grunge_Spots_0",
  "DV_Grunge_Spots_1",
  "DV_Grunge_Spots_2",
  "DV_Grunge_Stone_0",
  "DV_Grunge_Stone_1",
  "DV_Grunge_Stone_2",
  "DV_Grunge_Stone_3",
  "DV_Grunge_Stone_4",
  "DV_Grunge_Stone_5",
  "DV_Grunge_Stucco_0",
  "DV_Grunge_Stucco_1",
  "DV_Grunge_Stucco_2",
  "DV_Grunge_Wood_0",
  "DV_Grunge_Wood_1",
  "DV_Grunge_Wood_2",
] as const;

// The average values are in linear space.
export const textureAverageValues = [
  0.247, 0.444, 0.374, 0.763, 0.23, 0.083, 0.939, 0.856, 0.659, 0.421, 0.016, 0.021, 0.5, 0.199, 0.312, 0.101, 0.221,
  0.136, 0.036, 0.307, 0.062, 0.372, 0.174, 0.224, 0.251, 0.139, 0.52, 0.156, 0.587, 0.703, 0.247,
] as const;

type TextureName = (typeof textureNames)[number];

export const proceduralTextures: readonly TextureName[] = ["DV_Grunge_Noise_White"] as const;

export const maskTextureNames = [
  "Mask_Stone_BlueBonnet01",
  "Mask_Stone_Chopped01",
  "Mask_Stone_Cobblestone01",
  "Mask_Stone_Drystack01",
  "Mask_Stone_Elktown01",
  "Mask_Stone_Fieldstone01",
  "Mask_Stone_Hackett01",
  "Mask_Stone_Ledgestone01",
  "Mask_Stone_Limestone01",
  "Mask_Stone_Manorstone01",
  "Mask_Stone_OhioLimestone01",
  "Mask_Stone_Patio01",
  "Mask_Stone_Rubblestone01",
  "Mask_Stone_Stonestack01",
  "Mask_Stone_VeneerCobblestone01",
  "Mask_Stone_Weatherledge01",
] as const;

export const heightMapTextureNames = [
  "Mask _Stone_Fieldstone01_H",
  "Mask_Stone_Chopped01_H",
  "Mask_Stone_Cobblestone01_H",
  "Mask_Stone_Drystack01_H",
  "Mask_Stone_Elktown01_H",
  "Mask_Stone_Fieldstone01_H",
  "Mask_Stone_Hackett01_H",
  "Mask_Stone_Ledgestone01_H",
  "Mask_Stone_Limestone01_H",
  "Mask_Stone_Manorstone01_H",
  "Mask_Stone_OhioLimestone01_H",
  "Mask_Stone_Patio01_H",
  "Mask_Stone_Rubblestone01_H",
  "Mask_Stone_Stonestack01_H",
  "Mask_Stone_VeneerCobblestone01_H",
  "Mask_Stone_Weatherledge01_H",
] as const;

export const normalMapNames = [
  "normalmaps/DV_Grunge_Grass_01_normal",
  "normalmaps/DV_Grunge_Grass_02_normal",
  "normalmaps/DV_Pack_StoneMortar_01_normal",
  "normalmaps/DV_Pack_StoneStacked_01_normal",
  "normalmaps/New_Graph_normal",
  "normalmaps/New_Graph_normal_flipped",
] as const;
